// node-modules
import ScrollMagic from 'scrollmagic';
import { TweenLite } from 'gsap/TweenLite';

// constants
import { ROOT_CLASS, SELECTORS } from '@/scripts/constants';

// other
import { controller } from '@/components/_scrollmagic';

// assets
import './scrollToTop.scss';

export default function scrollToTopScene(container = document) {
  const scrollToTop = document.createElement('div');
  const content = container.querySelector('.content');
  if (!content) return false;

  scrollToTop.className = `${ROOT_CLASS} scroll-to-top`;
  scrollToTop.dataset.role = 'scroll-to-top';
  document.body.appendChild(scrollToTop);
  scrollToTop.addEventListener('click', () => {
    TweenLite.to(window, 0.8, { scrollTo: { y: 0, autoKill: false } });
  });

  const scene = new ScrollMagic.Scene({
    triggerElement: content,
    triggerHook: 'onLeave',
  })
    .setClassToggle(scrollToTop, SELECTORS.active)
    // .addIndicators({ name: 'Scroll to top' })
    .addTo(controller);

  return {
    destroy() {
      scrollToTop.remove();
      scene.destroy();
    },
  };
}



// WEBPACK FOOTER //
// ./components/_scrollmagic/scenes/scrollToTop/scrollToTop.js